export default {
    title: "Průzkum předložen",
    header: "@:views.survey.submitted.title",
    message: "Děkujeme vám za vaši reakci.",
}